// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"c632549d","354":"4ff67c2d","626":"e2537902","678":"c632549d","799":"eb8ee359"}[chunkId] + ".chunk.css";
};